import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {MatButton} from "@angular/material/button";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {MatTooltip} from "@angular/material/tooltip";
import {FormsModule} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {environment} from "@enviroment/environment";
import {decryptData} from "@shared/utils/decrypt";
import Swal from "sweetalert2";
import {openBlankWindow, openExternalUrl} from "@shared/utils/window.utils";

@Component({
  selector: 'app-noticias-alerta-modal',
  templateUrl: './noticias-alerta-modal.component.html',
  styleUrls: ['./noticias-alerta-modal.component.scss'],
  standalone: true,
  imports: [
    MatDialogActions,
    MatButton,
    MatDialogContent,
    NgForOf,
    MatDialogTitle,
    NgIf,
    NgClass,
    MatTooltip,
    FormsModule
  ]
})
export class NoticiasAlertaModalComponent implements OnInit{
  tipo: number = 1;
  busqueda: string = '';
  alertasFiltradas: any[] = [];
  noticias: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { noticias: any[], tipo: number },
    private dialogRef: MatDialogRef<NoticiasAlertaModalComponent>,
    private http: HttpClient
  ) {
    this.tipo = data.tipo;
  }

  ngOnInit() {
    this.mapearNoticias()
  }

  mapearNoticias() {
    this.noticias = (this.data.noticias || []).map((item: any) => {
      let obj: any;
      try {
        // Si el backend manda {json: string}
        const raw = typeof item.json === 'string' ? JSON.parse(item.json) : item.json ?? item;
        switch (this.tipo) {
          case 1:
            // Mapeo explicito y limpio de campos (y valores default por si falta alguno)
            obj = {
              id: raw.id || '',
              imagen: raw.imagen || null,
              medicamento: raw.medicamento || '',
              codigoNacional: raw.codigoNacional || '',
              observ: raw.observ || '',
              fechaInicio: raw.fechaInicio || '',
              ffin: raw.ffin || '',
              tipoProblemaSuministro: raw.tipoProblemaSuministro || '',
            };
            break;
          case 2:
            obj = {
              num: raw.num || '',
              referencia: raw.referencia || '',
              asunto: raw.asunto || '',
              fecha: raw.fecha || '',
              imagen: raw.imagen || null,
              enlace: raw.enlace || '',
              enlace_json: raw.enlace_json || '',
              url: this.getEnlaceReal(raw.enlace_json),
            };
            break;
          case 3:
            obj = {
              id: raw.id || '',
              titulo: this.decodeHtml(raw.titulo || ''),
              breve: this.decodeHtml(raw.breve || ''),
              imagen: raw.imagen || null,
              autor: this.decodeHtml(raw.autor || ''),
              categoria: this.decodeHtml(raw.categoria || ''),
              enlace: raw.enlace || '',
              publicacion: this.decodeHtml(raw.publicacion || ''),
            };
            break;
          case 4:
            obj = {
              id: raw.id || '',
              titulo: this.decodeHtml(raw.titulo || ''),
              breve: this.decodeHtml(raw.breve || ''),
              imagen: raw.imagen || null,
              autor: this.decodeHtml(raw.autor || ''),
              categoria: this.decodeHtml(raw.categoria || ''),
              enlace: raw.enlace || '',
              publicacion: this.decodeHtml(raw.publicacion || ''),
            };
            break;
          case 5:
            obj = {
              id: raw.id || '',
              titulo: this.decodeHtml(raw.titulo || ''),
              breve: this.decodeHtml(raw.breve || ''),
              autor: this.decodeHtml(raw.autor || ''),
              categoria: this.decodeHtml(raw.categoria || ''),
              enlace: raw.enlace || '',
              publicacion: this.decodeHtml(raw.publicacion || ''),
            };
            break;
          default:
            obj = { ...raw };
            break;
        }
      } catch (e) {
        obj = {};
      }
      return obj;
    });
    this.alertasFiltradas = [...this.noticias];
  }

  close() {
    this.dialogRef.close();
  }

  filtrarAlertas() {
    const filtro = (this.busqueda || '').trim().toLowerCase();
    if (!filtro) {
      this.alertasFiltradas = [...this.noticias];
      return;
    }
    if (this.tipo === 1) {
      // Problemas de suministro
      this.alertasFiltradas = this.noticias.filter(n =>
        (n.medicamento || '').toLowerCase().includes(filtro) ||
        (n.codigoNacional || '').toLowerCase().includes(filtro)
      );
    } else if (this.tipo === 2) {
      // Notas de seguridad
      this.alertasFiltradas = this.noticias.filter(n =>
        (n.asunto || '').toLowerCase().includes(filtro) ||
        (n.referencia || '').toLowerCase().includes(filtro) ||
        (n.num || '').toLowerCase().includes(filtro)
      );
    } else if (this.tipo === 3 || this.tipo === 4 || this.tipo === 5) {
      // Noticias
      this.alertasFiltradas = this.noticias.filter(n =>
        (n.titulo || '').toLowerCase().includes(filtro) ||
        (n.breve || '').toLowerCase().includes(filtro) ||
        (n.autor || '').toLowerCase().includes(filtro) ||
        (n.categoria || '').toLowerCase().includes(filtro) ||
        (n.publicacion || '').toLowerCase().includes(filtro)
      );
    }  else {
      // Filtro general para futuros tipos
      this.alertasFiltradas = this.noticias.filter(n =>
        Object.values(n).some(v => typeof v === 'string' && v.toLowerCase().includes(filtro))
      );
    }
  }

  getPlaceholder(): string {
    switch (this.tipo) {
      case 1:
        return 'Buscar por medicamento o codigo nacional';
      case 2:
        return 'Buscar por nota, referencia o fecha';
      case 3:
        return 'Buscar por titulo, resumen, autor o fecha';
      default:
        return 'Buscar...';
    }
  }

  decodeHtml(html: string): string {
    if (!html) return '';
    // Intenta decodificar dos veces
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    txt.innerHTML = txt.value;
    return txt.value;
  }


  esObservacionAmarilla(observ: string): boolean {
    if (!observ) return false;
    const texto = observ.toLowerCase();
    return texto.includes('distribucion controlada') || texto.includes('unidades limitadas');
  }

  getEnlaceReal(enlaceJson: string): string {
    if (!enlaceJson) return '';
    const match = enlaceJson.match(/url=(.*)$/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  getTitulo(): string {
    switch (this.tipo) {
      case 1: return 'PROBLEMAS DE SUMINISTRO';
      case 2: return 'NOTAS DE SEGURIDAD';
      case 3: return 'NOTICIAS';
      case 4: return 'ALERTAS';
      case 5: return 'PRINCIPIOS ACTIVOS';
      default: return 'INFORMACION';
    }
  }

  abrirHerramientaVidal(noticia: any) {
    // helper local para validar URL absoluta http(s)
    const isValidHttpUrl = (u: any): boolean => {
      try {
        const url = new URL(String(u).trim());
        return url.protocol === 'http:' || url.protocol === 'https:';
      } catch {
        return false;
      }
    };

    // 1) Si existe noticia.url y es http(s) absoluto: abrir directo y salir
    const url = noticia?.url;
    if (url && isValidHttpUrl(url)) {
      openExternalUrl(url);
      return;
    }

    const ruta = noticia.enlace;
    if (!ruta) {
      Swal.fire('Sin enlace', 'No hay ruta/enlace en la noticia', 'warning').then( );
      return;
    }

    this.http.post<any>(
      `${environment.backend_url}VIDAL_Tools/getContenidoDesdeRuta`,
      JSON.stringify({ ruta }),
      {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'json'
      }
    ).subscribe({
      next: (res: any) => {
        if (!res || !res.data) {
          Swal.fire('Sin datos', 'No se recibio informacion valida desde VIDAL', 'warning').then();
          return;
        }

        try {
          const key = environment.encryptionKey;
          const htmlString = decryptData(res.data, key) || '';
          const cleaned = htmlString.trim();

          // 1) Parsear el HTML (aunque venga sin <body>)
          const parser = new DOMParser();
          const doc = parser.parseFromString(cleaned, 'text/html');

          // 2) ¿Hay contenido visible? (texto o elementos “visibles”)
          if (!this.hasVisibleVidalContent(doc, cleaned)) {
            Swal.fire(
              'Contenido incompleto',
              'El documento recibido no contiene informacion visible.',
              'warning'
            ).then();
            return;
          }

          // 3) Abrir en nueva pestaña (usa el HTML tal cual te llego)
          const nuevaVentana = openBlankWindow();
          if (nuevaVentana) {
            nuevaVentana.document.open();
            nuevaVentana.document.write(cleaned);
            nuevaVentana.document.close();
          } else {
            Swal.fire('Error', 'No se pudo abrir la nueva pestaña. Verifica el bloqueo de pop-ups.', 'error').then();
          }
        } catch (e) {
          Swal.fire('Error', 'No se pudo desencriptar el contenido de VIDAL', 'error').then();
        }
      },
      error: () => {
        Swal.fire('Error', 'Error al obtener el contenido de VIDAL', 'error').then();
      }
    });

  }

  /** Verifica si el HTML tiene contenido visible aunque no traiga <body>. */
  private hasVisibleVidalContent(doc: Document, originalHtml: string): boolean {
    // Tomar lo que haya en body; si body viene vacio, usa el HTML original
    const container = document.createElement('div');
    container.innerHTML = (doc?.body?.innerHTML?.trim() || '') || originalHtml;

    // Remover ruido que no aporta visibilidad
    container.querySelectorAll('script, style, link[rel="stylesheet"], meta, title').forEach(el => el.remove());

    // Texto visible
    const text = (container.textContent || '').replace(/\s+/g, ' ').trim();
    if (text.length > 0) return true;

    // Elementos visuales comunes
    if (container.querySelector('img, table, ul, ol, p, div, article, section, h1, h2, h3, h4, h5, h6, iframe, video')) {
      return true;
    }

    return false;
  }

}
